import Accordion from "./components/Accordion/Accordion";
import styles from "./TextAccordions.module.scss";
import TextAccordionsBlockProps from "./TextAccordionsProps.interface";

import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import Paragraph from "components/Paragraph/Paragraph";
import React, { FunctionComponent } from "react";
import useAnchor from "blocks/hooks/useAnchor";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const TextAccordions: FunctionComponent<TextAccordionsBlockProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    // Text Settings
    const headlineCaseClass = props.settings.headlineCase ? styles[`case_${props.settings.headlineCase}`] : undefined;

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                {/* Text */}
                <div className={styles.content}>
                    {/* Tagline */}
                    {props.content.tagline ? (
                        <span className={styles.tagline}>{props.content.tagline}</span>
                    ) : null}

                    {/* Headline */}
                    {props.content.headline ? (
                        <DynamicHeading className={combineClasses(styles.headline, headlineCaseClass)} text={props.content.headline} headlineSize={props.settings.headlineSize} headlineWeight={props.settings.headlineWeight} />
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}

                    {/* Buttons */}
                    {props.content.buttons && props.content.buttons.length > 0 ? (
                        <div className={styles.buttons}>
                            {props.content.buttons.map((button, index) => {
                                return (
                                    <Button key={index} to={button.content.link} className={styles.button} variant={button.content.variant} {...button.content}>{button.content.label}</Button>
                                );
                            })}
                        </div>
                    ) : null}
                </div>

                {/* Accordions */}
                <div className={styles.accordions_wrapper}>
                    <div className={styles.list}>
                        {props.content.accordions && props.content.accordions.map((item, index) => {
                            return (
                                <Accordion design={props.settings.design ? props.settings.design : undefined} key={index} {...item} />
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TextAccordions;
